import { consented } from "./consent"
import Cookies from "js-cookie"
import find from "lodash/find"

// Domain cookies are ignored when visiting an IP address, and Cypress makes
// requests via IP by default. Reconfiguring it to use DNS is a little involved.
// This method will conditionally set a host-only cookie in test in order to
// work around the IP issue, but set domain cookies in all other environments.
const defaultCookieOptions = () => {
  const domain = document.body.dataset.siteDomain

  if (!domain || document.body.dataset.railsEnv === "test") {
    return {}
  } else {
    return { domain }
  }
}

export const getCookieWithConsent = (itemKey, consentType, defaultValue) => {
  if (consented(consentType)) {
    // eslint-disable-next-line banhammer/no-restricted-functions
    return Cookies.get(itemKey) || defaultValue
  }

  return defaultValue
}

export const setCookieWithConsent = (itemKey, itemValue, consentType, cookieOptions) => {
  if (consented(consentType)) {
    // eslint-disable-next-line banhammer/no-restricted-functions
    Cookies.set(itemKey, itemValue, { ...defaultCookieOptions(), ...cookieOptions })
  }
}

export const removeCookieWithDefaultOptions = (itemKey, cookieOptions) => {
  Cookies.remove(itemKey, { ...defaultCookieOptions(), ...cookieOptions })
}

const defaultExperimentCookieOptions = (itemKey, itemValue) => {
  return {
    ...defaultCookieOptions(),
    sameSite: "Lax",
    expires: 365,
    path: "/",
  }
}

export const setExperimentCookie = (enrolments) => {
  const data = Object.entries(enrolments)
    .map(([experimentId, variant]) => `${experimentId}.${variant}`)
    .sort()
    .join("*")

  // eslint-disable-next-line banhammer/no-restricted-functions
  if (Cookies.get("mk_ex") !== data) {
    // eslint-disable-next-line banhammer/no-restricted-functions
    Cookies.set("mk_ex", data, defaultExperimentCookieOptions())
  }
}

export const getExperimentCookie = (experiments) => {
  // eslint-disable-next-line banhammer/no-restricted-functions
  const cookieValue = Cookies.get("mk_ex")
  const enrolments = {}
  if (!cookieValue) {
    return enrolments
  }

  cookieValue.split("*").forEach((idAndVariant) => {
    const [experimentId, variant] = idAndVariant.split(".")
    const experiment = find(experiments, (experiment) => experiment.id === experimentId)
    if (!experiment || experiment.variants[variant] === undefined) {
      return
    }

    enrolments[experimentId] = variant
  })

  return enrolments
}
